export const environment = {
  production: false,
  name: 'staging',
  backendUrl: 'https://api.streaks.stage.splash.tech/api/game',
  bridgeUrl: 'https://api.streaks.stage.splash.tech/bridge',
  quizFrontendUrl: 'https://quiz-staging.splash.tech',
  loaderAssetsUrl: 'https://loader-dev.splash.tech',
};
